import classNames from 'classnames';
import { HTMLAttributes } from 'react';

export function DebugPre(props: HTMLAttributes<HTMLPreElement>) {
  return <pre {...props} className={classNames('bg-gray-400 rounded text-black p-2 whitespace-pre-wrap break-all', typeof props.onClick === 'function' && 'cursor-pointer hover:bg-gray-300', props.className)} />
}
